import { render } from "./Feeder.vue?vue&type=template&id=6c3f39d0&scoped=true"
import script from "./Feeder.vue?vue&type=script&lang=js"
export * from "./Feeder.vue?vue&type=script&lang=js"

import "./Feeder.vue?vue&type=style&index=0&id=6c3f39d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c3f39d0"

export default script